import axios from '../../axios'

export const processPromisesMixin = {
  methods: {
    async getRequestWithProjectIdPromise(endpoint) {
      const responseProjectId = await this.getProjectId
      const params = {
        params: {
          project_id: responseProjectId
        }
      }
      return await axios.get(endpoint, params)
    },

    async getUsersPromise() {
      const responseProjectId = await this.getProjectId
      const params = {
        params: {
          project_id: responseProjectId
        }
      }
      return await axios.get('user-project-attributions', params)
    },

    async getStatusReportsCommentsPromise() {
      const config = {
        params: {
          report_id: this.statusReportId
        }
      }
      return await axios.get('status-report-comments', config)
    }
  }
}
